import { render, staticRenderFns } from "./relationInformation.vue?vue&type=template&id=f7869e46&scoped=true"
import script from "./relationInformation.vue?vue&type=script&lang=js"
export * from "./relationInformation.vue?vue&type=script&lang=js"
import style0 from "./relationInformation.vue?vue&type=style&index=0&id=f7869e46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7869e46",
  null
  
)

export default component.exports